import { z } from 'zod';
import apiClient from '../lib/apiClient';

const ValidateDomainSchema = z.object({
	url: z.string().min(1, 'URL is required'),
	clientId: z.string().min(1, 'Application ID is required'),
	clientSecret: z.string().min(1, 'Application key is required'),
});

export type ValidateDomainInput = z.infer<typeof ValidateDomainSchema>;
export type ValidateDomainResponse = {
	success: boolean;
	data: {
		installed?: boolean;
		activated?: boolean;
		requiresInstall?: boolean;
		message?: string;
		domain?: string;
		memberId?: string;
	};
};

export async function validateBitrixDomain(input: ValidateDomainInput): Promise<ValidateDomainResponse> {
	const payload = ValidateDomainSchema.parse(input);
	const res = await apiClient.post<ValidateDomainResponse>('/bitrix/validate-domain', payload);
	return res as unknown as ValidateDomainResponse;
}

export type BitrixStatusResponse = {
	success: boolean;
	data: { installed: boolean; domain?: string; memberId?: string };
};

// export default {
// 	validateBitrixDomain,
// };

export async function getBitrixStatus(): Promise<BitrixStatusResponse> {
	const res = await apiClient.post<BitrixStatusResponse>('/bitrix/status', {});
	return res as unknown as BitrixStatusResponse;
}

export type OpenChannelsResponse = {
	success: boolean;
	result?: unknown;
};

export async function getOpenChannels(): Promise<OpenChannelsResponse> {
	const res = await apiClient.post<OpenChannelsResponse>('/bitrix/proxy-app', { params: 'openchannel' });
    return res as unknown as OpenChannelsResponse;
}

export type GetOpenChannelLinkInput = { line: string };
export type GetOpenChannelLinkResponse = {
	success: boolean;
	data: { linked: boolean; line?: string; channelId?: number; isActive?: boolean; channel?: { id: number; nameChannel?: string | null; phoneChannel?: string | null } };
};

export async function getOpenChannelLink(input: GetOpenChannelLinkInput): Promise<GetOpenChannelLinkResponse> {
	const res = await apiClient.post<GetOpenChannelLinkResponse>('/bitrix/openchannel/link/get', input);
	return res as unknown as GetOpenChannelLinkResponse;
}

export type SaveOpenChannelLinkInput = { line: string; channelId: number; confirm?: boolean };
export type SaveOpenChannelLinkResponse = {
	success: boolean;
	data: {
		created?: boolean;
		updated?: boolean;
		linked: boolean;
		requiresConfirm?: boolean;
		message?: string;
		current?: { channelId: number; nameChannel?: string | null; phoneChannel?: string | null };
		target?: { channelId: number };
		line?: string;
	channelId?: number;
	isActive?: boolean;
	};
};

export async function saveOpenChannelLink(input: SaveOpenChannelLinkInput): Promise<SaveOpenChannelLinkResponse> {
	const res = await apiClient.post<SaveOpenChannelLinkResponse>('/bitrix/openchannel/link/save', input);
	return res as unknown as SaveOpenChannelLinkResponse;
}

export type SetOpenChannelActiveInput = { line: string; isActive: boolean };
export type SetOpenChannelActiveResponse = {
	success: boolean;
	data: { linked: boolean; line: string; channelId: number; isActive: boolean };
};

export async function setOpenChannelActive(input: SetOpenChannelActiveInput): Promise<SetOpenChannelActiveResponse> {
	const res = await apiClient.post<SetOpenChannelActiveResponse>('/bitrix/openchannel/active/set', input);
	return res as unknown as SetOpenChannelActiveResponse;
}

export type UninstallBitrixResponse = { success: boolean; data: { installed: false } };

export async function uninstallBitrix(): Promise<UninstallBitrixResponse> {
	const res = await apiClient.post<UninstallBitrixResponse>('/bitrix/uninstall', {});
	return res as unknown as UninstallBitrixResponse;
}

